<template>
  <ion-page :lang="$i18n.locale">
    <ion-header>
      <!-- <ion-toolbar>topbar</ion-toolbar> -->
    </ion-header>
    <ion-content
      :id="id"
      fullscreen="false"
      class="master"
      :scroll-events="enableScrollEvent"
      @ionScroll="onScroll"
    >
      <div
        v-if="showFilterModal"
        class="z-[99] w-[100vw] h-[calc(--app-height)] fixed inset-0 bg-[#0B0C0F99] bg-opacity-50 flex items-center md:justify-center"
      >
        <div
          v-if="showFilterModal"
          class="z-[99] w-[100vw] h-[calc(--app-height)] lg:w-[400px] lg:h-[600px] fixed lg:static inset-0"
        >
          <FilterModal
            :filter-items="dropdownItems"
            :filterHeader="clickedFilter?.displayText"
            :filterType="clickedFilter?.type"
            :filterTypeId="clickedFilter?.typeId"
          />
        </div>
      </div>
      <LogoutPopup
        :show="showLogoutPopup"
        @close-modal="toggleLogoutPopup()"
      ></LogoutPopup>

      <Header v-if="showHeader" @open-modal="toggleLogoutPopup()" />
      <div class="fixed top-[72px] left-0 z-[30] w-screen ios-safe-area-top-offset">
        <AnnouncementBanner
          ref="ticker-tape"
          v-show="showAnnouncementBar"
          :isCloseable="false"
          @closeAnnouncementBar="closeAnnouncementBar"
          class="text-tape"
        >
          Tell us how GIC 2 was for you!
          <br class="md:hidden" />
          <router-link
            to="/forms/gic-feedback"
            data-event-tracking="gic-survey-ticker-tape-cta"
          >
            <button
              class="rounded-full bg-[#161616] text-tape-button text-white px-4 py-2 mt-2 md:mt-0 md:ml-6"
            >
              Go to survey
            </button>
          </router-link>
        </AnnouncementBanner>
      </div>
      <main
        class="lg:flex h-full lg:h-auto ios-safe-area-main"
        :class="showAnnouncementBar ? 'pt-[184px] md:pt-[144px]' : 'pt-[73px]'"
      >
        <slot class="flex-1 pb-16 lg:pb-0" test="test"> </slot>
      </main>
    </ion-content>
    <ion-footer> </ion-footer>
  </ion-page>
</template>
<script>
import { IonPage, IonHeader, IonContent, IonFooter } from "@ionic/vue";
import Header from "../components/common/Header.vue";
import { mapState } from "vuex";
import { useAuth0 } from "@auth0/auth0-vue";
import LogoutPopup from "@/components/HomePage/LogoutPopup.vue";
import FilterModal from "@/components/ResourcesPage/FilterModal.vue";
import { useCookies } from "vue3-cookies";
import { clearLoginPathObj } from "@/utils/redirect-uri";
import { clearLoginInterval } from "@/utils/login-tracking";
import AnnouncementBanner from "@/components/common/AnnouncementBanner.vue";

export default {
  components: {
    IonPage,
    IonHeader,
    IonContent,
    IonFooter,
    Header,
    LogoutPopup,
    FilterModal,
    AnnouncementBanner,
  },
  props: {
    pageTitle: {
      type: String,
      default: "",
    },
    enableScrollEvent: {
      type: Boolean,
      default: false,
    },
    noLogin: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: "ion-content",
    },
  },
  setup() {
    const { cookies } = useCookies();
    const { user } = useAuth0();
    return { cookies, user };
  },
  data() {
    return {
      showLogoutPopup: false,
      cookies: null,
      showAnnouncementBar: false,
      cookies: null,
    };
  },
  computed: {
    ...mapState("filter", [
      "showFilterModal",
      "filterTypeScheduleMapping",
      "clickedFilter",
      "schedule",
    ]),
    showHeader() {
      return !this.$route.path.includes("home");
    },
    dropdownItems() {
      if (this.clickedFilter && this.clickedFilter.type === "Sessions") {
        return this.filterTypeScheduleMapping[this.clickedFilter.typeId];
      }

      return this.schedule;
    },
  },
  async mounted() {
    clearLoginInterval(this.user ? this.user.sub : "");
    if (!this.noLogin) {
      await this.$store.dispatch("profile/fetchProfile");
    }
    if (!this.cookies.get("showGICAnnouncementBar")) {
      this.showAnnouncementBar = true;
    }
  },
  methods: {
    toggleLogoutPopup() {
      this.showLogoutPopup = !this.showLogoutPopup;
    },
    onScroll(event) {
      this.$emit("on-scroll", event);
    },
    closeAnnouncementBar() {
      console.log("close");
      this.showAnnouncementBar = false;
      this.cookies.set("showAnnouncementBar", true);
    },
  },
};
</script>
<style scoped>
ion-toolbar {
  --border-color: transparent;
  --background: transparent;
  --ion-color-base: transparent !important;
}

ion-content.master {
  --padding-bottom: 0px;
}

.footer-md::before {
  display: none;
}

/* ion-footer {
  position: fixed;
  bottom: 0;
  width: 100vw;
} */

.box-shadow {
  box-shadow: 0px 1px 25px 0px #0000001a;
}

/* iOS safe area adjustments */
.ios-safe-area-top-offset {
  top: calc(72px + env(safe-area-inset-top));
}

/* Override Tailwind padding-top for iOS safe area - handles all padding cases */
.ios-safe-area-main[class*="pt-\[73px\]"] {
  padding-top: calc(73px + env(safe-area-inset-top)) !important;
}

.ios-safe-area-main[class*="pt-\[184px\]"] {
  padding-top: calc(184px + env(safe-area-inset-top)) !important;
}

@media (min-width: 768px) {
  .ios-safe-area-main[class*="pt-\[144px\]"] {
    padding-top: calc(144px + env(safe-area-inset-top)) !important;
  }
}
</style>
